import { words }           from 'utils/dictionary';
import { colors }          from 'utils/colors';
import { sizeStateType }   from 'reducer/types';
import { objType }         from 'types';
import { makeStyles }           from 'makeStyles';

var clsx = require('classnames')


const useStyles = makeStyles()(() => ({
    small: {
        fontSize: 15,
      },
      big: {
        fontSize: 19,
      },
      menu: {
        position:        'absolute',
        border:          '1px solid #D3D4D5',
        backgroundColor: '#FFF',
        overflowX:       'hidden',
        boxShadow:       '0px 4px 10px rgba(0,0,0,0.15)',
        transition:      'height 0.3s, opacity 0.4s',
  
       '&::-webkit-scrollbar': {
          width: '5px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#CCC',
          borderRadius:    10
        } 
      },
      title: {
        height:         50,
        width:          '100%',
        minWidth:       250,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        textAlign:      'center',
        fontWeight:     'bold',
        paddingLeft:    5,
        paddingRight:   5,
        cursor:         'default',
      },
      item: {
        height:       50,
        width:        '100%',
        minWidth:     250,
        display:      'flex',
        alignItems:   'center',
        textAlign:    'left',
        paddingLeft:   5,
        paddingRight:  5,
        cursor:     'pointer',
        '&:hover': {
          backgroundColor: '#E6E6EA'
        }
      }
}))

type MenuProps = {
  sizeState:       sizeStateType;
  menuStyle:       objType;
  dropDownItems:   string[];
  variant:         string;
  lang:            string;
  manualVal:       string;
  manualOn:        boolean;
  handleItemClick: (val: string, ind: number) => void;
}

const Menu: React.FC<MenuProps> = ({ 
  sizeState,
  menuStyle,
  dropDownItems,
  variant,
  lang,
  manualOn,
  manualVal,
  handleItemClick
}) => {

  const { classes } = useStyles();


  return (

                
    <div 
       className = { classes.menu }
       style     = { menuStyle } 
     >
      {
        variant === 'links' &&
        <div className = { clsx(classes.title, sizeState.wideScreen ? classes.big : classes.small) }>
            { `${ words['links_to_programs'][lang] }` }
        </div>
      }
      {
         dropDownItems.map((val, ind) => {

           return(
              <div 
                 key       = { `${ val }{}{}++${ ind }=` }
                 dir       = 'rtl'
                 className = { clsx(classes.item, sizeState.wideScreen ? classes.big : classes.small) }
                 onClick   = { () => { handleItemClick(val, ind) }}
                 style     = {{
                     border: manualOn && manualVal === val ? `2px solid ${ colors.blue }` : undefined
                 }}
              >
                 { `${ words[val] && words[val][lang] ? words[val][lang] : val }` }
              </div> 
           )
         })
      }
    </div>         
            
  );
}


export default Menu